// src/hooks/useIdleLogout.js
import { useEffect, useRef } from "react";
import { logoutUser } from "./auth";
import { ENVIRONMENT } from "../config";

const useIdleLogout = (timeoutMinutes = 30) => {
  const timerRef = useRef();

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      logoutUser();
    }, timeoutMinutes * 60 * 1000); // e.g. 30 mins
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    for (const event of events) {
      window.addEventListener(event, resetTimer);
    }

    resetTimer(); // start timer initially

    return () => {
      for (const event of events) {
        window.removeEventListener(event, resetTimer);
      }
      clearTimeout(timerRef.current);
    };
  }, []);
  if (ENVIRONMENT === "development") {
    console.log(timerRef);
  }
};

export default useIdleLogout;
